import React, { Component } from 'react';
import classes from './Quote.module.scss';

import {connect} from 'react-redux';
import RecommendedSolution from "./RecommendedSolution/RecommendedSolution";
import EmailForm from "./EmailForm/EmailForm";

import axios from 'axios';

import FormattedPrice from '../../components/FormattedPrice/FormattedPrice';
import Button from '../../components/Button/Button';
import Aux from '../../hoc/Aux';
import * as actionTypes from "../../store/actions";

class Quote extends Component {

    QuestionsData = require( '../../data/' + this.props.mode + '-questions.js' );

    Constants = require( '../../data/' + this.props.mode + '-constants.js' );

    state = {
        recommendations: {},
        not_recommended: {},
        quote_created: false,
    };

    constructor(props) {
        super(props);

        this.state.recommendations = this.buildRecommendations();
        this.state.not_recommended = this.buildNotRecommended( this.state.recommendations );
    }

    componentDidMount() {
        if( this.props.quote_saved === false ) {
            this.generateQuoteLog();
            this.setState({
                quote_created: true
            } );
        }

        this.resetScrollPosition();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.resetScrollPosition();
    }

    resetScrollPosition() {
        const currentScrollPosition = window.pageYOffset;

        const headingElement = document.getElementById( 'bf-instant-quote-heading' );

        if( headingElement ) {
            if( currentScrollPosition > headingElement.offsetTop ) {
                window.scrollTo( {
                    top: headingElement.offsetTop,
                    behavior: 'smooth'
                } );
            }
        }
    }

    buildRecommendations = () => {

        let recommendedProducts = {};
        let requiredProducts = {};

        // Loop through all question answers.
        this.props.question_answers.map( ( answerIndex, questionIndex ) => {

            // Get the answer provided to the current question.
            let answer = this.QuestionsData[ this.props.version ][ questionIndex ].answers[ answerIndex ];

            // Does this answer actually recommend a product?
            if( answer.hasOwnProperty( 'recommends' ) && answer.recommends.length > 0 ) {

                // Loop through the recommended products for this answer.
                return answer.recommends.map(recommended => {
                    // Get the recommended product details from Constants.
                    let recommendedSolution = this.Constants.SOLUTIONS[ recommended.solution ];

                    // Does this recommended product have any requirements? If so, add them to the required products list.
                    if( recommendedSolution.hasOwnProperty( 'requires' ) && recommendedSolution.requires.length > 0 ) {
                        recommendedSolution.requires.map( requiredSolution => {
                            if( ! requiredProducts.hasOwnProperty( requiredSolution ) ) {
                                // Set the initial value to an empty array so we can push items to it.
                                requiredProducts[requiredSolution] = [];
                            }

                            requiredProducts[requiredSolution].push( recommended.solution );

                            return null;
                        } );
                    }

                    // Add this product to the recommended products list.
                    recommendedProducts[recommended.solution] = recommended.reason;
                    return null;
                });
            }

            return null;

        } );

        // Do we have any required products?
        if( Object.keys( requiredProducts ).length ) {

            // Loop through them and see if they aren't already being recommended.
            Object.keys( requiredProducts ).map( requiredProduct => {

                if( Object.keys( recommendedProducts ).indexOf( requiredProduct ) === -1 ) {
                    // The required product is not already recommended, show that it is required and why.
                    recommendedProducts[ requiredProduct ] = this.buildRequirementReason( requiredProduct, requiredProducts[ requiredProduct ] );
                }

                return null;
            } );

        }

        // Do we qualify for the SEO bundle?
        const seoBundleProducts = this.Constants.SOLUTIONS.SEO_BUNDLE.includes;

        const recommendedProductKeys = Object.keys( recommendedProducts );

        if( seoBundleProducts.every( elem => recommendedProductKeys.indexOf( elem ) > -1 ) ) {

            recommendedProducts[ 'SEO_BUNDLE' ] = {};

            seoBundleProducts.map( seoBundleProduct => {
                // Add the reason why to the SEO Bundle.
                recommendedProducts[ 'SEO_BUNDLE' ][ seoBundleProduct ] = recommendedProducts[ seoBundleProduct ];

                // Remove the individual product from the recommended products list so we just show the bundle.
                delete recommendedProducts[ seoBundleProduct ];

                return null;
            } );

        }

        return recommendedProducts;

    };

    buildNotRecommended = ( recommendedProducts ) => {

        const recommendedProductKeys = Object.keys( recommendedProducts );

        let productsNotRecommended = {};

        this.props.question_answers.map( ( answerIndex, questionIndex ) => {

            let answer = this.QuestionsData[ this.props.version ][ questionIndex ].answers[ answerIndex ];

            if( answer.hasOwnProperty( 'not_recommended' ) ) {
                return answer.not_recommended.map(not_recommended => {
                    // Product must not already be recommended.
                    if( recommendedProductKeys.indexOf( not_recommended.solution ) === -1 ) {
                        // Product must not be part of the SEO Bundle if the SEO Bundle is recommended.
                        if( recommendedProductKeys.indexOf( 'SEO_BUNDLE' ) > -1 ) {
                            if( this.Constants.SOLUTIONS['SEO_BUNDLE'].includes.indexOf( not_recommended.solution ) === -1 ) {
                                // SEO Bundle was recommended, but this product was not part of it.
                                productsNotRecommended[not_recommended.solution] = not_recommended.reason;
                            }
                        } else {
                            // SEO Bundle was not recommended, so add this to the not recommended product list.
                            productsNotRecommended[not_recommended.solution] = not_recommended.reason;
                        }
                    }
                    return null;
                });
            }

            return null;

        } );

        return productsNotRecommended;
    };

    buildRequirementReason = ( requirement_key, requiredBy ) => {

        const requiredProductLabel = this.Constants.SOLUTIONS[ requirement_key ].label;

        let reasonsWhy = [];

        requiredBy.map( requiredByKey => {
            reasonsWhy.push( this.Constants.SOLUTIONS[ requiredByKey ].label );
            return null;
        } );

        if ( reasonsWhy.length ) {
            const lastItem = reasonsWhy.pop();

            if ( reasonsWhy.length ) {
                return reasonsWhy.join(', ') + ' and ' + lastItem + ' require ' + requiredProductLabel;
            } else {
                return lastItem + ' requires ' + requiredProductLabel;
            }
        }
    };

    generateQuoteLog = () => {
        const recommendedProducts = this.state.recommendations;
        const recommendedProductKeys = Object.keys( recommendedProducts );

        if( recommendedProductKeys.length === 0 ) {
            // No products were recommended.
            return;
        }

        let request_data = {
            hash: (+new Date()).toString(16),
            version: this.props.version,
            survey_data: JSON.stringify( this.props.question_answers ),
            mode: this.props.mode,
        };

        axios.post( this.Constants.ENDPOINTS.log, request_data )
            .then( result => {

                if( result.status === 201 ) {

                    this.props.quoteSaved( result.data.data.ID, result.data.data.hash );

                }
            });

    };

    redirectToCheckout = () => {

        const products = Object.keys( this.state.recommendations );

        if ( products.length ) {
            window.location = this.Constants.REF.checkoutBase + '?products=' + products.join(',').toLowerCase();
        }

    };

    render() {

        const recommendationKeys = Object.keys( this.state.recommendations );
        const notRecommendedKeys = Object.keys( this.state.not_recommended );

        let subTotalPrice = 0;
        let totalPrice = 0;

        const totalPriceWithConditionalDairylandDiscount = (totalPrice) => {
            return (
                (this.props.mode === 'dairyland') ?
                    (
                        <FormattedPrice price={( totalPrice - (totalPrice * .1)).toFixed(2)} />
                    ):(
                        <FormattedPrice price={totalPrice} />
                    )
            )
        }

        return (
            <Aux>

                <div className={classes.QuoteReset}>
                    This is a saved quote. <Button textLink={true} onButtonClick={() => this.props.resetQuote()} addClass={classes.QuoteResetButton}>Click here to get a new Instant Quote</Button>
                </div>

                <div className={classes.Quote}>
                    <h3 className={classes.QuoteTitle}>Here's Your Instant Quote</h3>

                    {( recommendationKeys.length > 0 ) ? (
                        <div id={(this.state.quote_created) ? 'new-quote-created' : null} className={classes.RecommendedProductsContainer}>
                            <h2 className={classes.HeadingRecommendedProducts}>Recommended Products</h2>
                            <div className={classes.RecommendedProducts}>
                                {this.Constants.ORDER.map( recommendation_key => {
                                    if( recommendationKeys.indexOf( recommendation_key ) > -1 ) {
                                        if( this.Constants.SOLUTIONS[recommendation_key].hasOwnProperty( 'discountedPrice' ) ) {
                                            totalPrice = (totalPrice + this.Constants.SOLUTIONS[recommendation_key].discountedPrice);
                                            subTotalPrice = (subTotalPrice + this.Constants.SOLUTIONS[recommendation_key].discountedPrice);
                                        } else {
                                            totalPrice = (totalPrice + this.Constants.SOLUTIONS[recommendation_key].price);
                                            subTotalPrice = (subTotalPrice + this.Constants.SOLUTIONS[recommendation_key].price);
                                        }

                                        return (
                                            <RecommendedSolution key={recommendation_key} solution={recommendation_key}
                                                                 verbiage="Recommended for you because..."
                                                                 reason={this.state.recommendations[recommendation_key]}/>
                                        );
                                    }

                                    return null;
                                })}
                            </div>

                            <div className={classes.RecommendedTotalContainer}>
                                <div className={classes.RecommendedTotal}>
                                   <>
                                        <div className={classes.RecommendedTotalPrice}>
                                            Total Price:
                                            {" "}
                                            {/*SEO Bundle span component will only render if in SEO Bundle.*/}
                                            {( recommendationKeys.indexOf( 'SEO_BUNDLE' ) > -1 ) && <span className={classes.ActualPrice}><FormattedPrice price={( totalPrice + this.Constants.SOLUTIONS['SEO_BUNDLE'].savings )}/></span>}
                                            {/* This component will only display/fire in Dairyland mode sans the SEO Discount.*/}
                                            { (recommendationKeys.indexOf( 'SEO_BUNDLE' ) === -1 && this.props.mode === 'dairyland' ) && <span className={classes.ActualPrice}><FormattedPrice price={( totalPrice)}/></span>}
                                            {" "}
                                            {/* Component determines if Dairyland discount applies or not.*/}
                                            {totalPriceWithConditionalDairylandDiscount(totalPrice)}
                                            /month
                                        </div>
                                       {/*SEO Bundle discount info div will only render if in SEO Bundle Mode.*/}
                                        {( recommendationKeys.indexOf( 'SEO_BUNDLE' ) > -1 ) && <div className={classes.SavingsDescription}>Price reflects ${this.Constants.SOLUTIONS['SEO_BUNDLE'].savings} savings when purchasing the {this.Constants.SOLUTIONS['SEO_BUNDLE'].label}.</div>}
                                   </>
                                  {/*  Dairyland discount div will only appear in Dairlyand mode*/}
                                  {(this.props.mode === 'dairyland') && <div className={classes.SavingsDescription}>A 10% Dairyland agent discount has been applied for an additional savings of ${(totalPrice * .1).toFixed(2)}.</div>}
                                 </div>
                            </div>


                        </div>
                    ) : (
                        <div className={classes.NoRecommendations}>
                            <strong>Holy cow! It sounds like your agency is in great shape!</strong> If you ever need help with your digital marketing in the future, just let us know.
                        </div>
                    ) }

                    {( recommendationKeys.length > 0 ) ? (
                        <EmailForm quoteId={this.props.quote_id}
                                   quoteHash={this.props.quote_hash}
                                   recommendedProducts={this.state.recommendations}
                                   notRecommendedProducts={this.state.not_recommended}
                        />
                    ) : null }

                    { ( notRecommendedKeys.length > 0 ) ? (
                        <Aux>
                            <div className={classes.NotRecommended}>
                                <h2 className={classes.HeadingNotRecommended}>Did you know we also offer...</h2>
                                {this.Constants.ORDER.map( not_recommended_key => {
                                    if( notRecommendedKeys.indexOf( not_recommended_key ) > -1 ) {
                                        return (
                                            <RecommendedSolution key={not_recommended_key} solution={not_recommended_key}
                                                                 verbiage="We didn't recommend this for you because..."
                                                                 reason={this.state.not_recommended[not_recommended_key]}/>
                                        );
                                    }

                                    return null;
                                })}
                            </div>
                        </Aux>
                    ) : null }

                </div>

            </Aux>
        );

    }

}

const mapStateToProps = state => {
    return {
        current_question_index: state.current_question_index,
        question_answers: state.question_answers,
        version: state.version,
        quote_saved: state.quote_saved,
        quote_id: state.quote_id,
        quote_hash: state.quote_hash,
        mode: state.mode,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        resetQuote: () => dispatch( { type: actionTypes.RESET_QUOTE } ),
        quoteSaved: ( quote_id, quote_hash ) => dispatch( { type: actionTypes.QUOTE_SAVED, quote_id: quote_id, quote_hash: quote_hash } )
    }
};

export default connect( mapStateToProps, mapDispatchToProps )( Quote );
